import React, { useState, useEffect } from 'react';
import { toast } from "react-toastify";
import ab1 from '../../images/about/about2.jpeg'
import './style.css'
import LoadingOverlay from '../loading/loading';
import service from '../../services/service';

const About = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getInformation();
    }, []);

    const getInformation = async () => {
        try {
            setLoading(true);
            const response = await service.view("information");
            if (response && !response.success) {
                toast.error(response.message);
                return;
            }
            setData(response.information)
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    }

    return(
        <div className="wpo-about-area section-padding">
            {loading && <LoadingOverlay />}
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-7 col-md-12 col-sm-12">
                        <div className="wpo-about-img">
                            <img src={ab1} alt=""/>
                        </div>
                    </div>
                    <div className="col-lg-5 col-md-12 colsm-12">
                        <div className="wpo-about-text">
                            <div className="wpo-section-title">
                                <span>About Us</span>
                                <h2>A Best Place <br/> to Enjoy </h2>
                            </div>
                            <p>{data && data.about && (`${data.about}`)}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About;